import React from 'react'
function NoRecord() {
    return (
        <div>No records found.</div> 
    )
}

export default NoRecord